<template>
  <div >
    <label for="norm-amount">{{ $t('insights.ui.norm.amount.label') }}</label>
    <input type="number" id="norm-amount" class="form-control" @change="emitConfig" v-model="config.normPerDayAmount">
  </div>
</template>

<script>
import generalMethods from "@/mixins/insights/generalMethods";

export default {
  mixins: [generalMethods],
  name: "NormPerDayAmount",
  props: ['editing', 'currentConfig'],
  created(){
    this.config = this.currentConfig
  }
}
</script>

<style scoped>

</style>